import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Booking } from "@app/core/booking/domain/model/booking";
import { BookingMapper } from "@app/core/booking/data/network/booking.mapper";
import { Club } from "@app/core/club/domain/model/club";
import { ClubMapper } from "@app/core/club/data/network/club.mapper";
import { ClubListApiResponse } from "@app/core/shared/domain/api-types-filtered";

@Injectable({
  providedIn: "root",
})
export class GetClubWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(token: string): Observable<Club[]> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_CLUBS_LIST_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response: ClubListApiResponse) => response.clubs.map(ClubMapper.deserialize)));
  }
}
